export const FilterOperator = {
    AND: 'and',
    OR: 'or'
};

export default FilterOperator;
